/* eslint-disable max-len */
import { AfterViewInit, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { NgxTippyDefaultProps } from 'ngx-tippy-wrapper';
import { RecurringRouteService } from '../recurring-route-details/recurring-route.service';
import moment, { Moment } from 'moment';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Tabs, TabsConfig } from '../tabs/tabs.interface';
import * as L from 'leaflet';
import * as R from 'leaflet-responsive-popup';
import { environment } from 'environments/environment';
import { ZuperDialogService } from '@zuper/components/zuper-dialog';
import _ from 'lodash';
import { ReplaySubject, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { antPath } from 'leaflet-ant-path';
import { environment as env } from 'environments/environment';
import { MapsService } from 'app/modules/maps/maps.service';
import { TemplateService } from '../../../../projects/dispatch-board/src/app/core/services/template.service';
import { HotToastService } from '@ngneat/hot-toast';
import { DispatchBoardService } from '../../../../projects/dispatch-board/src/app/components/dispatch-board/dispatch-board.service';
import { BryntumSchedulerProComponent } from '@bryntum/schedulerpro-angular-thin';
const H = window['H'];
@Component({
  selector: 'app-move-route-job',
  templateUrl: './move-route-job.component.html',
  styleUrls: ['./move-route-job.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MoveRouteJobComponent implements OnInit, AfterViewInit, OnDestroy {

  // Pass Source / Route Uid
  @Input() sourceRoute?: any;
  @Input() destinationRoute?: any;
  @Input() timezone?: any = this.utilityService.timeZone;
  @Input() holidays?: any = [];
  @Output() actionEmitter: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('moveConfirmationDialogContent', { static: true }) moveConfirmationDialogContent: TemplateRef<any>;
  @ViewChild('moveRouteScheduler') schedulerProComponent!: BryntumSchedulerProComponent;

  //Configs
  enableDistanceBetweenJobs: boolean = true;
  enableJobConflicts: boolean = true;

  //General
  dateTimeFormat: string = this.utilityService.dateTimeFormat;
  dateFormat: string = this.utilityService.dateFormat;
  timeFormat: string = this.utilityService.timeFormat;
  routeSelectionTypes: any[] = ['SOURCE', 'DESTINATION'];
  employeeSearchSubscription: Subscription;
  cancelRouteRequestSubject: Subject<void> = new Subject<void>();
  mapPopupData: { popupRef: null };
  isRouteJobChanged: boolean = false;
  isRouteMoveInProgress: boolean = false;
  maxAssigedToprofile: number = 4;
  today = moment();
  // eslint-disable-next-line @typescript-eslint/naming-convention
  infoBubbleText = {   ONE_INSTNACE: this.utilityService.getLocaleValue('recurring_route.move.eligibility.one_instances.message', 'Your move group consists of combination of both one-off jobs and instances from recurring job series. Saving the move will only move the selected job instances to the target route.'),
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ALL_INSTNACE: this.utilityService.getLocaleValue('recurring_route.move.eligibility.all_instances.message', 'Your move group consists ONLY of job instances from recurring job series. Saving the move will offer you an additional option to move not only the current but also, all the future instances of the recurring job series to the target route.')
  };
  moveConfirmationDialogData = { data: [], isPanelOpen: false, dialogInstance: null, selectedMovementType: 'ONE_INSTNACE', movementSummary: null };
  isEligibleForSeriesMovement: boolean = false;
  routePickerTippyProps: NgxTippyDefaultProps = {
    allowHTML: true,
    arrow: false,
    theme: 'light',
    hideOnClick: true,
    trigger: 'click',
    interactive: true,
    appendTo: document.body,
    placement: 'bottom',
    zIndex: 9999,
    maxWidth: '512',
    onShow: (instance: any): any => {
      if (this.routeSelectionType) {
        this.routePicker[this.routeSelectionType].tippyRef = instance;
      }
    },
    onHide: (): any => {
    }
  };
  filterTippyProps: NgxTippyDefaultProps = {
    allowHTML: true,
    arrow: false,
    theme: 'light',
    hideOnClick: false,
    trigger: 'click',
    interactive: true,
    appendTo: document.body,
    placement: 'bottom',
    maxWidth: '512',
    zIndex: 1000,
    onShow: (instance: any) => {
      this.initEmployeeSearchListner();
      this.filterTippyData.isOpened = true;
      this.filterTippyData.rollback = this.routeFilters;
      this.filterTippyData.instanceRef = instance;
    },
    onHide: () => {
      if (this.employeeSearchSubscription?.unsubscribe) {
        this.employeeSearchSubscription.unsubscribe();
      }
      this.filterTippyData.isOpened = false;
      this.filterTippyData.totalFilter = (this.routeFilters.users.selectedUsers?.length ? 1 : 0) + (this.routeFilters.skills.selectedSkills?.length ? 1 : 0);
    },
    onClickOutside: (instance: any, event: any) => {
      const ngSelectDropdown = document.querySelector('.ng-dropdown-panel');
      if (ngSelectDropdown && ngSelectDropdown.contains(event.target)) {
        return false; // Prevent onClickOutside for ng-select dropdown clicks
      }
      this.onFilterCancel();
      instance.hide();
    }
  };
  // eslint-disable-next-line @typescript-eslint/naming-convention
  modeOfTransportIcon = { 'CAR': 'ti-car', 'TRUCK': 'ti-truck', 'BIKE': 'ti-bike', 'WALK': 'ti-walk', 'PEDESTRIAN': 'ti-walk' };
  routeSelectionType: RoutePickerType;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  cdkDragConfig = { 'SOURCE': { showPlaceHolder: false }, 'DESTINATION': { showPlaceHolder: false } };
  // eslint-disable-next-line max-len, @typescript-eslint/naming-convention
  routePicker = { 'SOURCE': { tippyRef: null, routeNameOne: null, routeNameTwo: null, selectedRoute: null, isLoading: false, conflicts: {}, allConflicts: {}, isConflictLoading: false, isDisabled: false }, 'DESTINATION': { tippyRef: null, routeNameOne: null, routeNameTwo: null, selectedRoute: null, isLoading: false, conflicts: {}, allConflicts: {}, isConflictLoading: false, isDisabled: false } };
  // eslint-disable-next-line @typescript-eslint/naming-convention
  routePickerRollBack: any = { 'SOURCE': {}, 'DESTINATION': {} };
  // eslint-disable-next-line @typescript-eslint/naming-convention
  routeDistanceData = { 'SOURCE': {}, 'DESTINATION': {}, 'existingCustomObj': { 'SOURCE': {}, 'DESTINATION': {} }, 'isLoading': { 'SOURCE': true, 'DESTINATION': true } };
  selectedNavTab: 'SCHEDULER' | 'MAP' = 'MAP';
  routeParam: any = {};
  destinationSelectorNavTabs: Tabs[] = [
    {
      title: 'dispatchBoard.settings.map.title',
      dataKey: 'MAP',
      isEnabled: true
    },
    {
      title: 'dispatchBoard.settings.scheduler.title',
      dataKey: 'SCHEDULER',
      isEnabled: true
    }
  ];
  destinationSelectorNavTabConfig: TabsConfig = {
    size: 'lg',
    position: 'start',
    variant: 'borderless',
    tabBarGutter: 'space-x-6',
    showActionButton: false,
    extraClass: ''
  };
  isSchedulerHolidayTimeRangeMounted: boolean = false;
  metaData: any = this.utilityService.getLocaleValue('dispatch_board_metadata') || this.recurringRouteService.moveSchedulerConfig;

  //Filters
  filterTippyData = { isOpened: false, totalFilter: 0, instanceRef: null, rollback: { date: moment(), disableDateButton: { prev: false, next: false }, skills: { data: [], selectedSkills: [], isLoading: false }, users: { data: [], selectedUsers: [], isLoading: false } } };
  routeFilters = { date: moment().utc(false), disableDateButton: { prev: false, next: false }, skills: { data: [], selectedSkills: [], isLoading: false }, users: { data: [], selectedUsers: [], isLoading: false } };
  showAllRoutes: boolean = false;
  employeePagination = { loadingIndex: 1, totalPage: 1, keyword: '' };
  // eslint-disable-next-line @typescript-eslint/naming-convention
  employeeParamObj: any = { 'count': 10, 'page': 1, 'filter.is_assigned_to_team': true, 'populate_teams': true, 'filter.is_active': true };
  employeeValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();

  //Map
  map: any;
  tileLayer: any;
  activeGeoCords: number[];
  currentTitleType: string = 'DEFAULT';
  routeLayerGroup: any;
  platform = new H.service.Platform({
    apikey: env.hereMapKey
  });
  mapRouteData: Subject<any> = new Subject<any>();
  mapRouteDataSubscription: Subscription;
  allRouteData: any[] = [];
  routeListingData: any[] = [];
  navigateToSourceHomeLeafletControl: any;
  navigateToSourceEleRef: any;
  navigateToSourceClickHandler: any;

  //Scheduler
  schedulerInstance: any;
  schedulerProConfig: any;
  schedulerPresets = _.cloneDeep(this.dispatchBoardService.getSchedulerPresets());
  schedulerCurrentView: 'DAY' | 'WEEK' | 'MONTH' = 'DAY';
  schedulerEmployees = [];
  schedulerRoutes = [];
  schedulerJobs = [];
  schedulerAssignments = [];
  schedulerData: any;
  schedulerSearchKeyword: string = '';
  private mapTileUrl: string = window['mapTileUrl'];
  private satelliteUrl: string = null;
  private boundSetAsDestination: any;

  constructor(
    private localisationService: LocalisationService,
    private dataCollectorService: DataCollectorService,
    private recurringRouteService: RecurringRouteService,
    private utilityService: UtilityService,
    public dialogRef: MatDialogRef<MoveRouteJobComponent>,
    private zuperDialogService: ZuperDialogService,
    private mapService: MapsService,
    private toastService: HotToastService,
    private dispatchBoardTemplateService: TemplateService,
    private matDialog: MatDialog,
    private dispatchBoardService: DispatchBoardService,
    private dispatchTemplateService: TemplateService,
    @Inject(MAT_DIALOG_DATA) public dialogData
  ) {
    this.satelliteUrl = this.mapService.satelliteUrl;
    this.boundSetAsDestination = (event: Event, data: any): any => this.mapSetAsDestination(event, data);
  }

  ngOnInit(): void {
    this.localisationService.setDefaultLanguage();
    this.initDependencies();
    this.getAllCategories();
    this.setSchedulerConfig();
  }

  ngAfterViewInit(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((res) => {
        if (res?.coords?.latitude && res?.coords?.longitude) {
          this.activeGeoCords = [res.coords.latitude, res.coords.longitude];
          this.initMap(true);
        }
      }, (err) => {
        this.initMap(false);
      });
    }
    this.schedulerInstance = this.schedulerProComponent?.instance;
    if (this.schedulerInstance) {
      if (!this.isSchedulerHolidayTimeRangeMounted) {
        this.buildHolidaysTimeRange();
      }
    }
  }

  ngOnDestroy(): void {
    this.tearDown();
  }

  //General
  initDependencies(): void {
    if (!this.utilityService.companyConfig?.dispatch_board?.distance_time) {
      this.enableDistanceBetweenJobs = false;
    }
    this.routePicker.SOURCE.selectedRoute = this.sourceRoute;
    this.routePicker.DESTINATION.selectedRoute = this.destinationRoute;
    if (!this.routePicker.SOURCE.selectedRoute && this.dialogData?.data?.sourceRoute) {
      this.routePicker.SOURCE.selectedRoute = this.dialogData?.data?.sourceRoute;
    }
    if (!this.routePicker.DESTINATION.selectedRoute && this.dialogData?.data?.destinationRoute) {
      this.routePicker.DESTINATION.selectedRoute = this.dialogData?.data?.destinationRoute;
    }
    if (this.dialogData?.data?.timezone) {
      this.timezone = this.dialogData?.data?.timezone;
    }
    if (this.dialogData?.data?.holidays) {
      this.holidays = this.dialogData?.data?.holidays;
    }
    const availableRouteSelectionTypes: any[] = [];
    if (this.routePicker.SOURCE.selectedRoute) {
      availableRouteSelectionTypes.push('SOURCE');
    }
    if (this.routePicker.DESTINATION.selectedRoute) {
      availableRouteSelectionTypes.push('DESTINATION');
    }
    this.checkRouteSelectionData(availableRouteSelectionTypes);
    this.navigateToSourceClickHandler = this.navigateToSourceHomeLocation.bind(this);
  }

  drop(event: CdkDragDrop<string[]>): any {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }
    else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      this.getRouteJobConflicts();
    }
    this.jobCardDropListEntered(event);
    this.getDistanceBetweenJobs();
    this.refreshMapRoutes();
  }

  jobCardDropListEntered(event: any): void {
    if (event?.container?.id === 'sourceJobs' && !this.routePicker.SOURCE.selectedRoute?.jobs?.length) {
      this.cdkDragConfig.SOURCE.showPlaceHolder = true;
    }
    else {
      this.cdkDragConfig.SOURCE.showPlaceHolder = false;
    }
    if (event?.container?.id === 'destinationJobs' && !this.routePicker.DESTINATION.selectedRoute?.jobs?.length) {
      this.cdkDragConfig.DESTINATION.showPlaceHolder = true;
    }
    else {
      this.cdkDragConfig.DESTINATION.showPlaceHolder = false;
    }
  }

  checkRouteSelectionData(routeSelectionTypes: any[] = this.routeSelectionTypes, forceUpdate: boolean = false): void {
    routeSelectionTypes.forEach(async (routeSelectionType: any) => {
      if (this.routePicker[routeSelectionType].selectedRoute) {
        this.routePicker[routeSelectionType].isLoading = true;
        if (typeof this.routePicker[routeSelectionType].selectedRoute === 'string' && (!this.routePicker[routeSelectionType].isDisabled || forceUpdate)) {
          this.routePicker[routeSelectionType].selectedRoute = await this.getRouteDetails(this.routePicker[routeSelectionType].selectedRoute);
          this.getRouteJobConflicts([routeSelectionType]);
          if (this.routePicker[routeSelectionType].selectedRoute?.is_recurrence && !this.routePicker[routeSelectionType].selectedRoute?.recurring_route) {
            this.routePicker[routeSelectionType].selectedRoute['recurring_route'] = await this.getRecurringRouteDetails(this.routePicker[routeSelectionType].selectedRoute?.recurring_route_uid);
          }
          if (routeSelectionType === 'SOURCE' && this.routePicker[routeSelectionType].selectedRoute?.route_uid) {
            this.routePicker[routeSelectionType].isDisabled = true;
            this.routeFilters.date = moment(this.routePicker[routeSelectionType].selectedRoute?.departure).tz(this.timezone);
          }
        }
      }
      if (this.routePicker[routeSelectionType].selectedRoute) {
        this.routePicker[routeSelectionType].selectedRoute = this.formatRouteDetails([this.routePicker[routeSelectionType].selectedRoute])[0];
      }
      const routeDetailType: 'oneOffRoute' | 'recurringRouteInstance' = this.routePicker[routeSelectionType].selectedRoute?.is_recurrence ? 'recurringRouteInstance' : 'oneOffRoute';
      if (routeDetailType === 'oneOffRoute') {
        this.routePicker[routeSelectionType].routeNameOne = this.routePicker[routeSelectionType].selectedRoute?.route_name || '';
        this.routePicker[routeSelectionType].routeNameTwo = null;
      }
      else if (routeDetailType === 'recurringRouteInstance') {
        this.routePicker[routeSelectionType].routeNameOne = this.routePicker[routeSelectionType].selectedRoute?.recurring_route?.recurring_route_name || '';
        this.routePicker[routeSelectionType].routeNameTwo = this.routePicker[routeSelectionType].selectedRoute?.route_name || '';
      }
      this.routePicker[routeSelectionType].isLoading = false;
      if (routeSelectionType === 'SOURCE' && (!this.routePickerRollBack[routeSelectionType].selectedRoute || forceUpdate)) {
        this.routePickerRollBack[routeSelectionType] = _.cloneDeep(this.routePicker[routeSelectionType]);
      }
      if (routeSelectionType === 'DESTINATION') {
        this.routePickerRollBack[routeSelectionType] = _.cloneDeep(this.routePicker[routeSelectionType]);
      }
      this.refreshMapRoutes();
      this.getDistanceBetweenJobs();
      if (routeSelectionTypes?.length === 1) {
        this.navigateToRouteLocation(routeSelectionType, 'start', 16);
      }
    });
  }

  checkRouteChanges(): any {
    if (this.routePicker.SOURCE.selectedRoute?.route_uid && this.routePicker.DESTINATION.selectedRoute?.route_uid) {
      const sourceRouteUid = this.routePicker.SOURCE.selectedRoute?.jobs.map((job: any) => job?.job_uid || job?.job?.job_uid);
      const sourceOriginalRouteUid = this.routePickerRollBack.SOURCE.selectedRoute?.jobs.map((job: any) => job?.job_uid || job?.job?.job_uid);
      const destinationRouteUid = this.routePicker.DESTINATION.selectedRoute?.jobs.map((job: any) => job?.job_uid || job?.job?.job_uid);
      const destinationOriginalRouteUid = this.routePickerRollBack.DESTINATION.selectedRoute?.jobs.map((job: any) => job?.job_uid || job?.job?.job_uid);
      const isSourceChanged: boolean = !_.isEqual(sourceOriginalRouteUid, sourceRouteUid);
      const isDestinationChanged: boolean = !_.isEqual(destinationOriginalRouteUid, destinationRouteUid);
      if (isSourceChanged || isDestinationChanged) {
        this.isRouteJobChanged = true;
      }
      else {
        this.isRouteJobChanged = false;
      }
    }
    else {
      this.isRouteJobChanged = false;
    }
  }

  checkMovementEligibleForSeries(): any {
    if (this.routePicker.SOURCE.selectedRoute?.is_recurrence && this.routePicker.DESTINATION.selectedRoute?.is_recurrence &&
      !this.routePicker.SOURCE.selectedRoute?.isPastRoute && !this.routePicker.DESTINATION.selectedRoute?.isPastRoute &&
      this.routePicker.SOURCE.selectedRoute?.recurring_route?.recurring_route_uid !== this.routePicker.DESTINATION.selectedRoute?.recurring_route?.recurring_route_uid) {
      this.moveConfirmationDialogData.movementSummary = this.recurringRouteService.jobMovementSummary(this.routePickerRollBack.SOURCE.selectedRoute?.jobs || [], this.routePicker.SOURCE.selectedRoute?.jobs || [], this.routePickerRollBack.DESTINATION.selectedRoute?.jobs || [], this.routePicker.DESTINATION.selectedRoute?.jobs || []);
      if (this.moveConfirmationDialogData.movementSummary?.onlyRecurranceJobsInMovement) {
        this.isEligibleForSeriesMovement = true;
        const destinationRoute = { rrule: this.routePicker.DESTINATION.selectedRoute?.recurring_route?.rrule, endDate: new Date(this.routePicker.DESTINATION.selectedRoute?.recurring_route?.route_end), startDate: new Date(this.routePicker.DESTINATION.selectedRoute?.departure) };
        let checkDestinationRoute: boolean = true;
        if (this.moveConfirmationDialogData.movementSummary?.movedSourceJobs) {
          _.forEach(this.moveConfirmationDialogData.movementSummary?.movedSourceJobs || [], (jobsMovedFromSource: any) => {
            const jobMovedToSource = { rrule: null, startDate: null, endDate: null };
            jobMovedToSource.rrule = jobsMovedFromSource?.job?.recurring_job?.rrule;
            jobMovedToSource.startDate = new Date(jobsMovedFromSource?.job?.scheduled_start_time);
            jobMovedToSource.endDate = new Date(jobsMovedFromSource?.job?.recurring_job?.job_end);
            const isRruleMatched: boolean = this.recurringRouteService.checkScheduleAndCount({ rrule: destinationRoute.rrule, end: destinationRoute.endDate, start: destinationRoute.startDate, routeDetails: this.routePicker.DESTINATION.selectedRoute }, { rrule: jobMovedToSource.rrule, end: jobMovedToSource.endDate, start: jobMovedToSource.startDate });
            if (!isRruleMatched) {
              checkDestinationRoute = false;
              this.isEligibleForSeriesMovement = false;
              return false;
            }
          });
        }

        if (checkDestinationRoute && this.moveConfirmationDialogData.movementSummary?.movedDestinationJobs?.length) {
          const sourceRoute = { rrule: this.routePicker.SOURCE.selectedRoute?.recurring_route?.rrule, startDate: new Date(this.routePicker.SOURCE.selectedRoute?.departure), endDate: new Date(this.routePicker.SOURCE.selectedRoute?.recurring_route?.route_end) };
          _.forEach(this.moveConfirmationDialogData.movementSummary?.movedDestinationJobs || [], (jobsMovedFromDestination: any) => {
            const jobMovedToDestination = { rrule: null, startDate: null, endDate: null };
            jobMovedToDestination.rrule = jobsMovedFromDestination?.job?.recurring_job?.rrule;
            jobMovedToDestination.startDate = new Date(jobsMovedFromDestination?.job?.scheduled_start_time);
            jobMovedToDestination.endDate = new Date(jobsMovedFromDestination?.job?.recurring_job?.job_end);
            const isRruleMatched: boolean = this.recurringRouteService.checkScheduleAndCount({ rrule: sourceRoute.rrule, start: sourceRoute.startDate, end: sourceRoute.endDate, routeDetails: this.routePicker.SOURCE.selectedRoute }, { rrule: jobMovedToDestination.rrule, start: jobMovedToDestination.startDate, end: jobMovedToDestination.endDate });
            if (!isRruleMatched) {
              this.isEligibleForSeriesMovement = false;
              return false;
            }
          });
        }
      }
      else {
        this.isEligibleForSeriesMovement = false;
      }
    }
    else {
      this.isEligibleForSeriesMovement = false;
    }
  }

  unLockRoute(routeSelectionType: RoutePickerType): void {
    const routeDetails: any = this.routePicker[routeSelectionType].selectedRoute;
    const routeUid: string = routeDetails?.route_uid;
    const isRouteLocked = routeDetails?.is_locked;
    if (isRouteLocked && routeUid) {
      const routeUnlockDialogref = this.dispatchBoardService.routeDetailsChangeConfirmationDialog(routeDetails, 'unlockRoute');
      routeUnlockDialogref.afterClosed().subscribe((status: boolean) => {
        if (status) {
          const lockUpdateToast = this.toastService.loading(this.utilityService.getLocaleValue('route.lock.updating'));
          this.dispatchBoardService.updateRouteLock(routeUid, !isRouteLocked, (lockUpdateStatus: boolean) => {
            if (lockUpdateStatus) {
              this.routePicker[routeSelectionType].selectedRoute = routeUid;
              this.checkRouteSelectionData([routeSelectionType], true);
              if (this.showAllRoutes) {
                this.getRouteListingData(true);
              }
              lockUpdateToast.close();
            }
            else {
              lockUpdateToast.close();
            }
          });
        }
      });
    }
  }


  /* eslint-disable @typescript-eslint/naming-convention */
  formatRouteDetails(oneOffRoutes: any[]): any[] {
    oneOffRoutes = oneOffRoutes.map((oneOffRoute: any) => ({
      ...oneOffRoute,
      startDateTime: this.recurringRouteService.getStartEndTime(oneOffRoute?.departure, oneOffRoute?.route_end_time, true, this.timezone).join(' - '),
      departureDate: this.recurringRouteService.formatDateTime(oneOffRoute?.departure, this.dateFormat, this.timezone),
      departureDateTime: this.recurringRouteService.formatDateTime(oneOffRoute?.departure, this.dateTimeFormat, this.timezone),
      routeEndDateTime: this.recurringRouteService.formatDateTime(oneOffRoute?.route_end_time, this.dateTimeFormat, this.timezone),
      startLocation: this.recurringRouteService.getAddressText(oneOffRoute?.start_location),
      assigned_to: oneOffRoute?.assigned_to.map((assignee: any) => ({ ...assignee, hasValidProfilePicture: this.utilityService.hasValidProfilePicture(assignee?.user?.profile_picture) })),
      endLocation: this.recurringRouteService.getAddressText(oneOffRoute?.end_location),
      isPastRoute: moment(oneOffRoute?.departure).isBefore(moment(), 'day'),
      primaryColor: oneOffRoute?.color || '#0172CB',
      isPrimaryColorWhite: this.isWhiteHex(oneOffRoute?.color),
      secondaryColor: this.utilityService.getTextColorBasedOnBg(oneOffRoute?.color || '#0172CB'),
      rrText: oneOffRoute?.is_recurrence ? this.recurringRouteService.getRruleText(oneOffRoute?.recurring_route?.rrule) : null,
      jobs: oneOffRoute?.jobs.map((job: any) => ({
        ...job, job_title: this.recurringRouteService.getTitle(job?.job?.prefix, job?.job?.work_order_number, job?.job?.job_title),
        customerName: this.utilityService.concatTwoStrings(job?.job?.customer?.customer_first_name, job?.job?.customer?.customer_last_name) ||
          job?.job?.organization?.organization_name || job?.job?.property?.property_name || '',
        customerAddress: this.recurringRouteService.getAddressText(job?.job?.customer_address) || this.recurringRouteService.getAddressText(job?.job?.organization?.organization_address) || this.recurringRouteService.getAddressText(job?.job?.property?.property_address) || '',
        customerIcon: this.getCustomerIcon(job?.job),
        isRecurrence: job?.is_recurrence || job?.job?.is_recurrence,
        rruleText: (job?.is_recurrence || job?.job?.is_recurrence) && job?.job?.recurring_job?.rrule ? this.recurringRouteService.getRruleText(job?.job?.recurring_job?.rrule): '',
        isDelayedJob: job?.delayed_job || job?.job?.delayed_job,
        startEndTime: this.recurringRouteService.getStartEndTime(job?.job?.scheduled_start_time, job?.job?.scheduled_end_time).join(' - '),
      })).sort((jobOne: any, jobTwo: any) => jobOne?.sequence - jobTwo?.sequence)
    }));
    return oneOffRoutes;
  }

  getCustomerIcon(routeJobDetails: any): any {
    let iconText: string = 'ti-user';
    if (routeJobDetails.customer?.customer_first_name) {
      iconText = 'ti-user';
    }
    else if (routeJobDetails.organization?.organization_name) {
      iconText = 'ti-building';
    }
    else if (routeJobDetails.property?.property_address) {
      iconText = 'ti-building-estate';
    }
    return iconText;
  }

  isWhiteHex(hex: string): boolean {
    const normalizedHex = hex.toLowerCase();
    return normalizedHex === '#ffffff' || normalizedHex === '#fff';
  }

  /* eslint-enable @typescript-eslint/naming-convention */
  getRecurringRouteDetails(recurringRouteUid: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (recurringRouteUid) {
        const getRecurringRouteUrl = `${this.dataCollectorService.baseurl()}/routes/recurring/${recurringRouteUid}`;
        this.dataCollectorService.getData(getRecurringRouteUrl).subscribe(
          (response: any) => {
            resolve(response?.data || {});
          },
          (error: any) => {
            resolve({});
          });
      }
      else {
        resolve({});
      }
    });
  }

  getRouteDetails(routeUid: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const getRouteUrl = `${this.dataCollectorService.baseurl()}/routes/${routeUid}`;
      this.dataCollectorService.getData(getRouteUrl).subscribe(
        (response: any) => {
          resolve(response?.data || {});
        },
        (error: any) => {
          resolve({});
        });
    });
  }

  onRoutePickerOpen(routePickerType: RoutePickerType): void {
    this.routeSelectionType = routePickerType;
  }

  routePickerEventEmitter(event: any): void {
    if (event?.isSelected) {
      if (event?.data) {
        this.routePicker[this.routeSelectionType].selectedRoute = event?.data?.route_uid;
        if (this.routeSelectionType === 'DESTINATION' && this.routePickerRollBack?.SOURCE) {
          this.routePicker.SOURCE = _.cloneDeep(this.routePickerRollBack?.SOURCE);
        }
        this.refreshMapRoutes();
        this.getRouteJobConflicts(['SOURCE']);
        this.checkRouteSelectionData([this.routeSelectionType]);
      }
      this.routePicker[this.routeSelectionType].tippyRef.hide();
    }
  }

  clearRouteSelection(routeSelectionType: RoutePickerType): void {
    this.routePicker[routeSelectionType] = { tippyRef: null, routeNameOne: null, routeNameTwo: null, selectedRoute: null, isLoading: false, conflicts: {}, allConflicts: {}, isConflictLoading: false, isDisabled: false };
    this.routePicker.SOURCE = _.cloneDeep(this.routePickerRollBack?.SOURCE);
    this.getRouteJobConflicts(['SOURCE']);
    this.refreshMapRoutes();
    this.getDistanceBetweenJobs();
  }

  resetRouteMoveActions(): void {
    this.routePicker = _.cloneDeep(this.routePickerRollBack);
    this.refreshMapRoutes();
    this.getRouteJobConflicts();
    this.getDistanceBetweenJobs();
  }

  resetAllMoveChanges(): void {
    const resetConfirmationDialog = this.zuperDialogService.open({
      title: this.utilityService.getLocaleValue('recurring_route.move.reset_all_changes', 'Reset all changes'),
      message: this.utilityService.getLocaleValue('recurring_route.move.reset_all_changes.message', 'Are you sure to reset all changes in the source and destination routes?'),
      type: 'error',
      actions: {
        confirm: {
          show: true,
          label: 'Yes',
          color: 'error',
          confirmDisplayKey: 'yes',
        },
        cancel: {
          show: true,
          label: 'Cancel'
        }
      },
      extraClass: 'reset-route-move-dialog'
    });
    resetConfirmationDialog.afterClosed().subscribe((status: boolean) => {
      if (status) {
        this.resetRouteMoveActions();
      }
    });
  }

  getRouteJobConflicts(routeSelectionTypes: any[] = this.routeSelectionTypes): void {
    if (this.enableJobConflicts) {
      routeSelectionTypes.forEach(async (routeSelectionType: any) => {
        if (this.routePicker[routeSelectionType]?.selectedRoute) {
          this.routePicker[routeSelectionType].isConflictLoading = true;
          try {
            this.routePicker[routeSelectionType].allConflicts = await this.recurringRouteService.getRecurringRouteInstanceConflicts(this.routePicker[routeSelectionType]?.selectedRoute, this.timezone);
          }
          catch {
            this.routePicker[routeSelectionType].isConflictLoading = false;
          }
          this.routePicker[routeSelectionType].isConflictLoading = false;
          if (this.routePicker[routeSelectionType].allConflicts?.conflicts?.length) {
            let conflictBucket: any = [];
            this.routePicker[routeSelectionType].allConflicts?.conflicts.forEach((conflictByType: any) => {
              if (conflictByType?.type && conflictByType?.count) {
                conflictBucket.push(...conflictByType?.conflicts);
              }
            });
            conflictBucket = _.compact(conflictBucket);
            conflictBucket = _.groupBy(conflictBucket, 'job_uid');
            this.routePicker[routeSelectionType].conflicts = conflictBucket;
          }
        }
      });
    }
    else {
      this.routePicker.SOURCE.conflicts = {};
      this.routePicker.DESTINATION.conflicts = {};
    }
  }

  getDistanceBetweenJobs(): void {
    if (this.enableDistanceBetweenJobs) {
      if (this.utilityService.isEmptyOrUndefined(this.routePicker.SOURCE.selectedRoute)) {
        this.routeDistanceData.isLoading.SOURCE = true;
      }
      if (this.utilityService.isEmptyOrUndefined(this.routePicker.DESTINATION.selectedRoute)) {
        this.routeDistanceData.isLoading.DESTINATION = true;
      }
      if (this.routeDistanceData.existingCustomObj.SOURCE?.['routeUid'] !== this.routePicker.SOURCE.selectedRoute?.route_uid) {
        this.routeDistanceData.existingCustomObj.SOURCE = {};
        this.routeDistanceData.SOURCE = {};
      }
      if (this.routeDistanceData.existingCustomObj.DESTINATION?.['routeUid'] !== this.routePicker.DESTINATION.selectedRoute?.route_uid) {
        this.routeDistanceData.existingCustomObj.DESTINATION = {};
        this.routeDistanceData.DESTINATION = {};
      }
      // eslint-disable-next-line @typescript-eslint/naming-convention
      this.recurringRouteService.getDistanceBetweenJobs({ SOURCE: this.routePicker.SOURCE.selectedRoute, DESTINATION: this.routePicker.DESTINATION.selectedRoute }, this.routeDistanceData.existingCustomObj, { SOURCE: this.routeDistanceData.SOURCE, DESTINATION: this.routeDistanceData.DESTINATION }, (distanceObj: any) => {
        this.routeDistanceData.existingCustomObj = distanceObj?.customObj;
        this.routeDistanceData.SOURCE = distanceObj?.distanceData?.SOURCE;
        this.routeDistanceData.DESTINATION = distanceObj?.distanceData?.DESTINATION;
        this.routeDistanceData.isLoading.SOURCE = false;
        this.routeDistanceData.isLoading.DESTINATION = false;
      });
    }
    else {
      this.routeDistanceData.SOURCE = {};
      this.routeDistanceData.DESTINATION = {};
    }
  }

  jobCardContextMenuAction(action: 'REMOVE_JOB' | 'SHOW_IN_MAP', routeJobDetails: any, routeSelectionType: 'SOURCE' | 'DESTINATION'): void {
    if (action === 'REMOVE_JOB') {
      const jobUid = routeJobDetails?.job_uid || routeJobDetails?.job?.job_uid;
      if (jobUid) {
        const routeJobs: any[] = _.cloneDeep(this.routePicker[routeSelectionType].selectedRoute?.jobs || []);
        let newRouteJobs: any[] = [];
        if (routeJobs?.length) {
          newRouteJobs = routeJobs.filter((routeJob: any) => (routeJob?.job_uid || routeJob?.job?.job_uid) !== jobUid);
        }
        this.routePicker[routeSelectionType].selectedRoute['jobs'] = newRouteJobs;
        if (routeJobs?.length !== newRouteJobs?.length) {
          this.refreshMapRoutes();
          this.getDistanceBetweenJobs();
        }
      }
    }
    else if (action === 'SHOW_IN_MAP') {
      if (this.selectedNavTab === 'SCHEDULER') {
        this.onDestinationSelectorNavTabChange('MAP');
      }
      const hasJobGeoCords = this.recurringRouteService.isJobHasGeoCords(routeJobDetails?.job);
      if (hasJobGeoCords) {
        const jobLocation: any[] = routeJobDetails?.job?.customer_address?.geo_cordinates || routeJobDetails?.geo_cordinates;
        this.panMapView(jobLocation, 15);
      }
    }
  }

  //General
  eventEmitter(event: any): void {
    this.actionEmitter.next(event);
    this.dialogRef.close(event);
  }

  closeDrawer(): void {
    const closeEvent = { isClosed: true };
    this.eventEmitter(closeEvent);
    this.tearDown();
  }

  moveDialogSubmit(): void {
    if (this.isEligibleForSeriesMovement) {
      this.openMoveConfirmationDialog();
    }
    else {
      this.onMoveComplete();
    }
  }

  onMoveComplete(): void {
    this.isRouteMoveInProgress = true;
    const updatingToast = this.toastService.loading(this.utilityService.getLocaleValue('recurring_route.toast.route_jobs_updating'));
    const updateAllInstances: boolean = this.moveConfirmationDialogData.selectedMovementType === 'ALL_INSTNACE';
    this.recurringRouteService.moveRouteJobs(this.routePicker.SOURCE.selectedRoute, this.routePicker.DESTINATION.selectedRoute, updateAllInstances, (status: boolean) => {
      this.closeMoveConfirmationDialog();
      updatingToast.close();
      if (status) {
        this.toastService.success(this.utilityService.getLocaleValue('recurring_route.toast.route_jobs_updated'));
        const closeEvent = { isClosed: true, isRouteChanged: true, sourceRoute: this.routePicker.SOURCE.selectedRoute, destinationRoute: this.routePicker.DESTINATION.selectedRoute };
        this.eventEmitter(closeEvent);
      }
      this.isRouteMoveInProgress = false;
    });
  }

  onDestinationSelectorNavTabChange(selectedTab: 'SCHEDULER' | 'MAP'): void {
    this.selectedNavTab = selectedTab;
    if (selectedTab === 'MAP') {
      if (this.map) {
        //Need to refresh map after rendering (small delay needed here)
        setTimeout(() => {
          this.map.invalidateSize();
        });
        this.mountRouteData();
      }
    }
    else if (selectedTab === 'SCHEDULER') {
      if (!this.schedulerInstance && this.schedulerProComponent) {
        this.schedulerInstance = this.schedulerProComponent?.instance;
      }
      if (this.schedulerInstance) {
        if (!this.isSchedulerHolidayTimeRangeMounted) {
          this.buildHolidaysTimeRange();
        }

      }
      if (!this.showAllRoutes) {
        this.onToggleShowAllRoutes();
      }
      else {
        this.mountRouteData();
      }
    }
  }

  onSchedulerDateChange(): void {
    this.getRouteListingData();
  }

  setSchedulerScrollPosition(schedulerInstance: any, schedulerStartDate: any, currentView: 'DAY' | 'WEEK' | 'MONTH'): void {
    if (schedulerInstance) {
      const scrollOption = {
        animate: {
          easing: 'easeFromTo',
          duration: 1000
        },
        block: 'start'
      };
      if (currentView === 'DAY') {
        const currentDate = moment(schedulerStartDate);
        const isSameDate = moment().isSame(currentDate, 'd');
        if (isSameDate) {
          setTimeout(() => {
            schedulerInstance.scrollToNow(scrollOption);
          }, 200);
        }
        else {
          const date: string = moment(currentDate).format('YYYY-MM-DD');
          const businessStartTime: string = this.dispatchBoardService.getBusinessHours('start');
          const businessStartDateTime = moment(date + ' ' + businessStartTime, 'YYYY-MM-DD HH:mm:ss').toDate();
          setTimeout(() => {
            schedulerInstance.scrollToDate(businessStartDateTime, scrollOption);
          }, 200);
        }
      }
      else {
        schedulerInstance.scrollTo(1);
      }
    }
  }

  schedulerDateIncrement(type: 'next' | 'prev'): void {
    const selectedDate = this.routeFilters.date.clone();
    if (type === 'prev' && selectedDate.isSameOrBefore(this.today)) {
      this.routeFilters.disableDateButton.prev = true;
      return;
    }
    else {
      this.routeFilters.disableDateButton.prev = false;
      this.routeFilters.disableDateButton.next = false;
    }
    this.routeFilters.date = this.routeFilters.date.add(type === 'next' ? 1 : -1, 'd').clone();
    this.getRouteListingData();
  }

  updateFilterCount(): any {
    return {
      type: 'PRIMARY',
      displayKey: this.filterTippyData?.totalFilter || '0',
      displayName: this.filterTippyData?.totalFilter || '0',
      displayType: 'listingCount'
    };
  }

  openMoveConfirmationDialog(): void {
    this.moveConfirmationDialogData.dialogInstance = this.matDialog.open(this.moveConfirmationDialogContent, {
      panelClass: ['move-confirm-dialog'],
      disableClose: false,
      data: { sourceRoute: this.routePicker.SOURCE.selectedRoute, destinationRoute: this.routePicker.DESTINATION.selectedRoute, summary: this.moveConfirmationDialogData.movementSummary }
    });
  }

  closeMoveConfirmationDialog(): void {
    if (this.moveConfirmationDialogData?.dialogInstance) {
      this.moveConfirmationDialogData.dialogInstance.close();
    }
  }

  tearDown(): void {
    if (this.map?.remove) {
      this.map.off();
      this.map.remove();
      this.map = null;
    }
    if (this.mapRouteDataSubscription?.unsubscribe) {
      this.mapRouteDataSubscription.unsubscribe();
    }
    if (this.schedulerInstance?.destroy) {
      this.schedulerInstance.destroy();
      this.schedulerInstance = null;
      this.schedulerProConfig = null;
    }
  }

  //Filter
  getAllCategories(): void {
    const skillUrl = `${this.dataCollectorService.baseurl()}/skills`;
    this.routeFilters.skills.isLoading = true;
    this.dataCollectorService.getData(skillUrl).subscribe(
      (response: any) => {
        this.routeFilters.skills.data = response?.data || [];
        this.routeFilters.skills.isLoading = false;
      },
      (error: any) => {
        this.routeFilters.skills.data = [];
        this.routeFilters.skills.isLoading = false;
      }
    );
  }

  getEmployees(input: string): void {
    this.employeePagination.keyword = input ? input : '';
    this.employeeParamObj['filter.keyword'] = this.employeePagination.keyword;
    this.employeeParamObj['page'] = 1;
    const urlParams = this.utilityService.constructParam(this.employeeParamObj);
    this.routeFilters.users.isLoading = true;
    const userUrl = `${this.dataCollectorService.baseurl()}/user/all`;
    this.dataCollectorService.getData(userUrl, urlParams).subscribe(
      (response: any) => {
        let employeeData = response?.data || [];
        employeeData = employeeData.map((employee: any) => ({ ...employee, name: `${employee?.first_name || ''} ${employee?.last_name || ''}` }));
        this.routeFilters.users.data = employeeData;
        this.employeePagination.loadingIndex = response.current_page;
        this.employeePagination.totalPage = response.total_pages;
        this.routeFilters.users.isLoading = false;
      },
      (error: any) => {
        this.routeFilters.users.isLoading = false;
      }
    );
  }

  onUserFilterSelectOpen(): void {
    this.getEmployees('');
  }

  onEmployeeScrollToEnd(): void {
    if (this.employeePagination.loadingIndex < this.employeePagination.totalPage) {
      this.employeePagination.loadingIndex++;
      this.employeeParamObj['filter.keyword'] = this.employeePagination.keyword;
      this.employeeParamObj['page'] = this.employeePagination.loadingIndex;
      this.routeFilters.users.isLoading = true;
      const urlParams = this.utilityService.constructParam(this.employeeParamObj);
      const userUrl = `${this.dataCollectorService.baseurl()}/user/all`;
      this.dataCollectorService.getData(userUrl, urlParams).subscribe(
        (response: any) => {
          this.routeFilters.users.isLoading = false;
          let employeeData = response?.data || [];
          employeeData = employeeData.map((employee: any) => ({ ...employee, name: `${employee?.first_name || ''} ${employee?.last_name || ''}` }));
          this.routeFilters.users.data = this.routeFilters.users.data.concat(employeeData);
        }, (error: any) => {
          this.routeFilters.users.isLoading = false;
        });
    }
  }

  initEmployeeSearchListner(): void {
    this.employeeSearchSubscription = this.employeeValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(500)).subscribe((term: string) => {
        this.getEmployees((term || '').trim());
      });
  }

  isEmployeeAssigned(item: any): boolean {
    if (this.routeFilters.users.selectedUsers.length) {
      const selectedUser: any = this.routeFilters.users.selectedUsers?.find(value => item?.user_uid === value?.user_uid);
      return selectedUser ? true : false;
    }
    return false;
  }

  userSelectionChanged(event: any, item: any): void {
    event.stopPropagation();
    if (!event?.target?.checked && this.routeFilters.users.selectedUsers?.find(value => item?.user_uid === value?.user_uid)) {
      this.unassignEmployee(item);
    }
  }

  unassignEmployee(item: any): void {
    if (this.routeFilters.users.selectedUsers?.length) {
      const selectedUsers: any[] = this.routeFilters.users.selectedUsers?.filter(value => item?.user_uid !== value?.user_uid);
      this.routeFilters.users.selectedUsers = selectedUsers;
    }
  }

  onFilterCancel(): void {
    this.routeFilters = this.filterTippyData.rollback;
    this.closeFilter();
  }

  onFilterApply(): void {
    this.getRouteListingData();
    this.closeFilter();
  }

  clearFilter(): void {
    this.routeFilters.skills.selectedSkills = [];
    this.routeFilters.users.selectedUsers = [];
    this.getRouteListingData();
    this.closeFilter();
  }

  closeFilter(): void {
    if (this.filterTippyData.instanceRef?.hide) {
      this.filterTippyData.instanceRef.hide();
    }
  }

  onToggleShowAllRoutes(): void {
    this.showAllRoutes = !this.showAllRoutes;
    if (this.showAllRoutes) {
      this.getRouteListingData(true);
    }
    else {
      this.routeListingData = [];
      this.refreshMapRoutes();
    }
  }

  //Maps
  initMap(isCoords: boolean): void {
    let center: any; let zoom: any;
    if (isCoords) {
      center = this.activeGeoCords;
      zoom = 11;
    } else {
      center = [40.6000135, -25.2314079];
      zoom = 3;
    }
    this.map = L.map('move-map-container', {
      center: center,
      zoom: zoom,
      zoomControl: false,
      attributionControl: true
    });
    this.map.whenReady(() => {
      this.addMapPopupEventListners();
    });
    L.control.zoom({ position: 'bottomright' }).addTo(this.map);
    this.tileLayer = L.tileLayer(this.mapTileUrl, { styleId: 997, edgeBufferTiles: 5 }).addTo(this.map);
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 500);
    this.intMapDependencies();
    this.refreshMapRoutes();
  }

  intMapDependencies(): void {
    this.mapRouteDataSubscription = this.mapRouteData.subscribe((routes: any[]) => {
      if (this.routeLayerGroup) {
        this.map.removeLayer(this.routeLayerGroup);
        this.routeLayerGroup = null;
      }
      this.routeLayerGroup = L.layerGroup();
      this.map.addLayer(this.routeLayerGroup);
      routes.forEach((route: any) => {
        this.getRoute(route?.start_location, route?.end_location, route);
      });
    });
    this.navigateToSourceHomeLeafletControl = L.control({
      position: 'bottomright'
    });
    this.navigateToSourceHomeLeafletControl.onAdd = (): any => {
      this.navigateToSourceEleRef = L.DomUtil.create('div', 'leaflet-bar custom-leaflet-bar leaflet-control border-b border-gray-300');
      this.navigateToSourceEleRef.innerHTML = '<a title="Navigate to source start location" class="map_home_icon ti ti-home text-xl"></a>';
      const homeIcon = this.navigateToSourceEleRef.querySelector('.map_home_icon');
      homeIcon.addEventListener('click', this.navigateToSourceClickHandler, true);
      return this.navigateToSourceEleRef;
    };
    this.navigateToSourceHomeLeafletControl.onRemove = (): any => {
      this.navigateToSourceEleRef.removeEventListener('click', this.navigateToSourceClickHandler, true);
    };
    this.map?.addControl(this.navigateToSourceHomeLeafletControl);
  }

  navigateToSourceHomeLocation(): void {
    this.navigateToRouteLocation('SOURCE', 'start', 16);
  }

  addMapPopupEventListners(): void {
    if (!this.map) {
      return;
    }
    this.map.on('popupopen', (event: any) => {
      const routeDetails = event?.popup?.options?.routeDetails;
      const setAsDestinationBtnRef = document.getElementById('set-as-destination-btn');
      if (setAsDestinationBtnRef) {
        setAsDestinationBtnRef.addEventListener('click', (btnEvent: any) => this.boundSetAsDestination(btnEvent, { routeDetails: routeDetails, popupRef: event?.popup }));
      }
      if (event?.popup?._closeButton) {
        event?.popup?._closeButton.setAttribute('href', 'javascript:void(0);');
      }
    });

    this.map.on('popupclose', (event: any) => {
      const routeDetails = event?.popup?.options?.routeDetails;
      const setAsDestinationBtnRef = document.getElementById('set-as-destination-btn');
      if (setAsDestinationBtnRef) {
        setAsDestinationBtnRef.removeEventListener('click', (btnEvent: any) => this.boundSetAsDestination(btnEvent, { routeDetails: routeDetails, popupRef: event?.popup }));
      }
    });
  }

  mapSetAsDestination(btnEvent: any, data: any): void {
    btnEvent.preventDefault();
    btnEvent.stopPropagation();
    const routeDetails = data?.routeDetails;
    const popupRef: any = data?.popupRef;
    if (routeDetails?.route_uid) {
      if (this.routePicker.DESTINATION.selectedRoute?.route_uid === routeDetails?.route_uid) {
        return;
      }
      this.routePicker.SOURCE = _.cloneDeep(this.routePickerRollBack?.SOURCE);
      this.routePicker.DESTINATION.selectedRoute = routeDetails?.route_uid;
      this.refreshMapRoutes();
      this.getRouteJobConflicts(['SOURCE']);
      this.checkRouteSelectionData(['DESTINATION']);
      if (this.map && popupRef) {
        this.map.closePopup(popupRef);
      }
    }
  }

  setTileLayer(type: string, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.map.removeLayer(this.tileLayer);
    this.currentTitleType = type;
    if (type === 'SATELLITE') {
      this.tileLayer = L.tileLayer(this.satelliteUrl, { styleId: 997, edgeBufferTiles: 5 }).addTo(this.map);
    } else if (type === 'DEFAULT') {
      this.tileLayer = L.tileLayer(this.mapTileUrl, { styleId: 997, edgeBufferTiles: 5 }).addTo(this.map);
    }

  }

  getRoute(origin: any, destination: any, route: any): void {
    let viaLocation = [];
    if (route?.jobs?.length > 0) {
      viaLocation = route?.jobs.map((job: any) => job?.geo_cords?.join(',') || job?.job?.customer_address?.geo_cordinates?.join(','));
    }
    viaLocation = _.compact(viaLocation);
    const originIcon = L.divIcon({
      className: 'map-pin-parent',
      html: this.mapService.getHomeAssignedToIcon(route.color ? route.color : '#1abc9c', route?.assigned_to || [], route?.jobs?.length),
      iconSize: [30, 42],
      iconAnchor: [15, 42]
    });
    if (origin?.geo_cords?.length === 2) {
      const homemarker = L.marker(origin?.geo_cords, {
        icon: originIcon,
        routeDetails: route
      }).addTo(this.routeLayerGroup);
      const popupOffset = L.point(5, -35);
      homemarker['routeDetails'] = route;
      homemarker.on('click', (homeMarkerInstance: any) => {
        const isDestinationRoute = this.checkRouteType(homeMarkerInstance?.sourceTarget?.routeDetails, 'DESTINATION');
        const isSourceRoute = this.checkRouteType(homeMarkerInstance?.sourceTarget?.routeDetails, 'SOURCE');
        L.popup({ offset: popupOffset, routeDetails: homeMarkerInstance?.sourceTarget?.routeDetails }).setLatLng(homemarker.getLatLng())
          .setContent(this.dispatchBoardTemplateService.getMoveRouteStartLocationPopupContent(homeMarkerInstance?.sourceTarget?.routeDetails, isSourceRoute, isDestinationRoute, this.timezone))
          .openOn(this.map);
      });
    }
    if (destination?.geo_cords?.length === 2) {
      const destinationIcon = L.divIcon({
        className: 'custom-div-icon',
        html: this.mapService.getDestinationIcon(route.color ? route.color : '#1abc9c'),
        iconSize: [40, 52],
        iconAnchor: [15, 42]
      });
      const isDestinationRoute = this.checkRouteType(route, 'DESTINATION');
      const isSourceRoute = this.checkRouteType(route, 'SOURCE');
      const routeDestinationPopupContent = this.dispatchBoardTemplateService.getMoveRouteEndLocationPopupContent(route, isSourceRoute, isDestinationRoute, this.timezone);
      const popup = R.responsivePopup({ minWidth: 280, offset: [5, -35] }).setContent(routeDestinationPopupContent);
      const destinationMarker = L.marker(destination?.geo_cords, {
        icon: destinationIcon
      }).bindPopup(popup).addTo(this.routeLayerGroup);
    }

    if (route?.jobs?.length > 0) {
      route.jobs.forEach((routeJob: any, index: number) => {
        this.getRouteJobMarker(route, routeJob, index + 1);
      });
    }

    let routingParameters: any;
    if (origin?.geo_cords) {
      routingParameters = {
        'routingMode': 'fast',
        'transportMode': 'car',
        'origin': origin?.geo_cords?.join(','),
        'spans': 'duration,baseDuration,length',
        'via': new H.service.Url.MultiValueQueryParameter(viaLocation),
        'return': 'polyline',
        'destination': null
      };
    }

    if (destination?.geo_cords) {
      routingParameters['destination'] = destination?.geo_cords?.join(',');
    } else if (viaLocation?.length) {
      routingParameters['destination'] = viaLocation[viaLocation?.length - 1];
    }
    if (!this.utilityService.isEmptyOrUndefined(routingParameters.destination)) {
      const router = this.platform.getRoutingService(null, 8);
      router.calculateRoute(routingParameters, (data: any) => {
        if (data?.routes[0]?.['sections']) {
          const sections = data.routes[0]['sections'];
          sections.forEach((section) => {

            const linestring = H.util.flexiblePolyline.decode(section.polyline);
            // ANIMATED LINE
            const antPolyline = antPath(linestring.polyline, {
              'delay': 600,
              'color': route.color ? route.color : '#1abc9c',
              'pulseColor': route.color ? route.color : '#1abc9c'
            });
            antPolyline.pause();

            antPolyline.addTo(this.routeLayerGroup);
          });
        }
      });
    }
  }

  getRouteJobMarker(routeDetails: any, jobDetails: any, jobCount: number): void {
    if (jobDetails.geo_cords?.length === 2) {
      const color = routeDetails?.color?.hex ? '#' + routeDetails.color.hex : routeDetails?.color;
      //Initializing Icon
      const icon = L.divIcon({
        className: 'custom-div-icon',
        html: this.mapService.getRouteJobIcon(color, jobCount),
        iconSize: [30, 42],
        iconAnchor: [15, 42]
      });
      if (!jobDetails?.job?.route) {
        jobDetails.job['route'] = routeDetails;
      }
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const jobDetailPopupContent = this.dispatchBoardTemplateService.getJobDetailsTemplate(jobDetails?.job, 'DAY', { map: { enable_map_view: true } }, true, { showRouteJobNumber: true, color: color, jobCount: jobCount });
      //Creating marker and binding events
      const popup = R.responsivePopup({ minWidth: 320, offset: [5, -35] }).setContent(jobDetailPopupContent);
      const marker = L.marker(jobDetails.geo_cords, {
        icon: icon
      }).bindPopup(popup).addTo(this.routeLayerGroup);
    }
  }

  setMapRouteData(routeData: any[], delay: number = 0): void {
    setTimeout(() => {
      this.mapRouteData.next(routeData);
    }, delay);
  }

  checkRouteType(routeDetails: any, type: 'SOURCE' | 'DESTINATION'): boolean {
    return routeDetails?.route_uid === this.routePicker[type]?.selectedRoute?.route_uid;
  }

  refreshMapRoutes(): void {
    this.allRouteData = _.compact([typeof this.routePicker.SOURCE.selectedRoute === 'object' ? this.routePicker.SOURCE.selectedRoute : null,
    typeof this.routePicker.DESTINATION.selectedRoute === 'object' ? this.routePicker.DESTINATION.selectedRoute : null,
    ...this.routeListingData]);
    this.setMapRouteData(this.allRouteData);
    this.checkRouteChanges();
    this.checkMovementEligibleForSeries();
  }

  clearRouteLisingData(): void {
    this.routeListingData = [];
    this.refreshMapRoutes();
    this.setSchedulerData([]);
  }

  panMapView(geoCords: any[], zoomLevel: number = 13): void {
    if (geoCords?.length === 2 && this.map) {
      this.map.setView(geoCords, zoomLevel);
    }
  }

  navigateToRouteLocation(routeSelectionType: 'SOURCE' | 'DESTINATION', type: 'start' | 'end' = 'start', zoomLevel: number = 13): void {
    const routeDetails = this.routePicker[routeSelectionType].selectedRoute;
    const [hasRouteStartLocation, routeStartLocation] = this.recurringRouteService.getRouteGeoCords(routeDetails, type);
    if (hasRouteStartLocation) {
      this.panMapView(routeStartLocation, zoomLevel);
    }
  }

  //Routes
  getRouteListingData(forceUpdate: boolean = false): void {
    this.cancelRouteRequestSubject.next();
    const routeCountUrl = `${this.dataCollectorService.baseurl()}/routes/count`;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const routesCountparams = { 'from_date': this.routeFilters.date.format('YYYY-MM-DD'), 'to_date': this.routeFilters.date.format('YYYY-MM-DD') };
    this.dataCollectorService.getData(routeCountUrl, routesCountparams)
      .pipe(takeUntil(this.cancelRouteRequestSubject))
      .subscribe((response) => {
        const routesCount = response?.data;
        const totalJobCount = _.sumBy(routesCount, 'job_routes');
        if (totalJobCount > 0) {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const routeDataUrl = `${this.dataCollectorService.baseurl()}/routes`;
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const routeDataParam = { 'page': 1, 'count': totalJobCount, 'from_date': this.routeFilters.date.format('YYYY-MM-DD'), 'to_date': this.routeFilters.date.format('YYYY-MM-DD'), 'filter.user_uid': this.routeFilters.users.selectedUsers.join(','), 'filter.skillset_uid': this.routeFilters.skills.selectedSkills.join(',') };
          if (_.isEqual(routeDataParam, this.routeParam) && !forceUpdate) {
            return;
          }
          else {
            this.clearRouteLisingData();
          }
          this.dataCollectorService.getData(routeDataUrl, routeDataParam)
            .pipe(takeUntil(this.cancelRouteRequestSubject))
            .subscribe((routes: any) => {
              this.routeListingData = routes?.data || [];
              this.routeParam = routeDataParam;
              this.mountRouteData();
            },
              (error: any) => {
                this.clearRouteLisingData();
              });
        }
        else {
          this.clearRouteLisingData();
        }
      },
        (error: any) => {
          this.clearRouteLisingData();
        });
  }

  mountRouteData(): void {
    if (this.selectedNavTab === 'MAP') {
      this.refreshMapRoutes();
    }
    else if (this.selectedNavTab === 'SCHEDULER') {
      this.setSchedulerData(this.routeListingData);
    }
  }
  //Scheduler
  setSchedulerConfig(): void {
    this.schedulerProConfig = {
      resourceTimeRanges: [],
      zoomOnTimeAxisDoubleClick: false,
      createEventOnDblClick: false,
      enableEventAnimations: false,
      readOnly: true,
      viewPreset: 'hourAndDay',
      columns: [
        {
          text: 'Name',
          field: 'name',
          type: 'template',
          autoHeight: true,
          editor: false,
          enableHeaderContextMenu: false,
          enableCellContextMenu: false,
          sortable: false,
          minWidth: 280,
          maxWidth: 280,
          width: 260,
          cls: 'w-full',
          headerRenderer: (): string => this.utilityService.getLocaleValue('text.routes', 'Routes'),
          summaries: [{
            sum: 'count',
            renderer: (resource: any): string => `<span class='text-medium font-medium'>${this.utilityService.getLocaleValue('dispatchBoard.scheduler.route.summary.total_routes')} : ${resource.sum}</span>`
          }],
          template: (employeeRecord: any): string => {
            const routeDetails = employeeRecord.record;
            return this.dispatchBoardTemplateService.getMoveJobSchedulerRouteTemplate(routeDetails);
          }
        }
      ],
      subGridConfigs: {
        locked: {
          minWidth: 280,
          maxWidth: 280,
          width: 280
        },
        normal: {
          flex: 1
        }
      },
      eventRenderer: (event): string => {
        const eventRecord: any = event.eventRecord;
        const renderData: any = event.renderData;
        const details = eventRecord.data;
        let template: string;
        if (details?.detailsType === 'route') {
          const routeDetails = details;
          const schedulerCardViewCount = Object.keys(this.metaData?.scheduler?.card_view).length || 1;
          const routeColor = this.utilityService.convertHexToRgba(routeDetails?.color || '#e67e22', '0.20');
          template = this.dispatchTemplateService.getRouteEventHeaderTemplate(routeDetails);
          renderData.style += `border-width: 1.2px; border-color: ${routeColor || '#e67e22'};`;
          renderData.eventColor = '#ffffff';
          renderData.eventStyle = 'border';
          this.schedulerInstance.rowHeight = schedulerCardViewCount * 47 + (45 / schedulerCardViewCount);
        }
        else if (details?.detailsType === 'job') {
          const jobDetails = details;
          const jobUid = jobDetails?.job_uid;
          const eventBorderColor = this.dispatchTemplateService.getCardColor(jobDetails, this.metaData?.scheduler.secondary_color);
          renderData.eventStyle = 'border';
          renderData.eventColor = `${this.utilityService.convertHexToRgba(this.dispatchTemplateService.getCardColor(jobDetails, this.metaData?.scheduler.primary_color) || '#887ECB')}`;
          renderData.style += `${this.metaData?.scheduler.primary_color === 'none' ? 'border-width: 2.5px; border-color: rgba(210 ,200,200, 0.3);' : ''} border-left-width: 5px; border-left-color: ${eventBorderColor || '#e67e22'};`;
          renderData.style += `height: ${Object.keys(this.metaData?.scheduler.card_view).length * 30}px`;
          template = this.dispatchTemplateService.getJobRendererTemplate('routes', 'scheduler', jobUid);
        }
        return template;
      },
      features: {
        dependencies: false,
        eventEdit : false,
        scheduleTooltip : {
          generateTipContent: ({ date, event, resourceRecord }): any =>{
            const hoveringDate = moment(date);
            const selectedFilterDate = this.routeFilters.date.clone().endOf('d');
            const isNextDay = hoveringDate.isAfter(selectedFilterDate);
            return `<div class='flex flex-col space-y-1.5'>
                      <div class='flex items-center space-x-1.5'>
                        <i class='ti ti-clock text-2xl'></i>
                        <span>${moment(date).format(this.dateTimeFormat)}</span>
                      </div>
                      ${isNextDay ? `<span class='text-red-500 max-w-96'>${this.utilityService.getLocaleValue('recurring_route.move.schedler.overnight_alert')}</span>`: ''}
                    </div>  `;
        }
        },
        eventBuffer: {
          showDuration: true,
          renderer: ({ eventRecord, postambleConfig, preambleConfig }: any): any => {
            const jobDetails = eventRecord.data;
            const modeOfTransport = jobDetails?.transport_mode || 'CAR';
            let travelTime: number = 0;
            if (eventRecord?.preamble) {
              travelTime = (eventRecord?.preamble?._magnitude || 0) * 60;
              preambleConfig.icon = `text-gray-500 b-icon b-fa-${this.dispatchBoardService.modeOfTransportIcons[modeOfTransport]}`;
              preambleConfig.text = travelTime !== 0 ? `${this.utilityService.convertSecondsToHours(travelTime, true)}` : `- ${this.utilityService.getLocaleValue('users.preview.work_hours.mins.label')}`;
            }

            if (eventRecord?.postamble) {
              travelTime = (eventRecord?.postamble?._magnitude || 0) * 60;
              postambleConfig.icon = `text-gray-500 b-icon b-fa-${this.dispatchBoardService.modeOfTransportIcons[modeOfTransport]}`;
              postambleConfig.text = travelTime !== 0 ? `${this.utilityService.convertSecondsToHours(travelTime, true)}` : `- ${this.utilityService.getLocaleValue('users.preview.work_hours.mins.label')}`;
            }
          },
          tooltipTemplate: (event: any): any => {
            const jobDetails = event.eventRecord.data;
            const type: 'preamble' | 'postamble' = event.before ? 'preamble' : 'postamble';
            const modeOfTransport = jobDetails?.transport_mode || 'CAR';
            let travelTime: number;
            let travelDistance: number;
            this.schedulerInstance?.features.eventTooltip.tooltip?.close();
            if (type === 'preamble') {
              travelTime = jobDetails?.time || 0;
              travelDistance = jobDetails?.distance || 0;
            }
            else if (type === 'postamble') {
              travelTime = jobDetails?.end_location_time || 0;
              travelDistance = jobDetails?.end_location_distance || 0;
            }
            return this.dispatchTemplateService.getRouteTravelDistanceTooltipTemplate(travelTime, travelDistance, modeOfTransport);
          }
        },
        timeAxisHeaderMenu: false,
        cellTooltip: {
          hoverDelay: 300,
          hideDelay: 100,
          allowOver: true,
          scrollAction: 'hide',
          anchorToTarget: false,
          hideOnDelegateChange: true,
          style: 'min-width : 400px !important;overflow : hidden;max-height:98% !important;',
          loadingMsg: this.utilityService.getLocaleValue('dispatchBoard.scheduler.employee.loading_details', 'Loading Details'),
          tooltipRenderer: (context: any): string => {
            const routeDetails = context.record.data;
            return this.dispatchBoardTemplateService.getMoveJobSchedulerRouteTooltipTemplate(routeDetails);
          },
        },
        nestedEvents: {
          eventLayout: 'stack',
          eventHeight: Object.keys(this.metaData?.scheduler.card_view).length * 30,
          barMargin: 10,
          allowDeNestingOnDrop: false,
          resourceMargin: 10
        },
        resourceTimeRanges: {
          enableMouseEvents: true,
        },
        timeRanges: {
          showHeaderElements: true,
          showCurrentTimeLine: true,
        },
        scheduleMenu: false,
        eventMenu: {
          items: {
            copyEvent: false,
            cutEvent: false,
            editEvent: false,
            deleteEvent: false,
            unassignEvent: false,
            splitEvent: false,
            setAsDestination: {
              text: this.utilityService.getLocaleValue('recurring_route.move.set_as_destination_route', 'Set as Destination Route'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-route text-2xl text-gray-700',
              onItem: (event: any): any => {
                const routeDetails = event.eventRecord.data;
                if (routeDetails?.route_uid) {
                  if (this.routePicker.DESTINATION.selectedRoute?.route_uid === routeDetails?.route_uid) {
                    return;
                  }
                  this.routePicker.SOURCE = _.cloneDeep(this.routePickerRollBack?.SOURCE);
                  this.routePicker.DESTINATION.selectedRoute = routeDetails?.route_uid;
                  this.refreshMapRoutes();
                  this.getRouteJobConflicts(['SOURCE']);
                  this.checkRouteSelectionData(['DESTINATION']);
                }
              }
            },
            showOnMap: {
              text: this.utilityService.getLocaleValue('rdispatchBoard.scheduler.event_menu.options.show_on_map', 'Show on Map'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-map text-2xl text-gray-700',
              onItem: (event: any): any => {
                const routeDetails = event.eventRecord.data;
                if (routeDetails) {
                  if (event.eventRecord.isParent) {
                    if (this.selectedNavTab === 'SCHEDULER') {
                      this.onDestinationSelectorNavTabChange('MAP');
                      if (routeDetails?.start_location?.geo_cords) {
                        this.panMapView(routeDetails?.start_location?.geo_cords, 15);
                      }
                    }
                  }
                  else {
                    this.jobCardContextMenuAction('SHOW_IN_MAP', routeDetails, null);
                  }
                }
              }
            }
          },
          processItems: (event: any): any => {
            const items: any = event.items;
            const eventRecord: any = event.eventRecord;
            if (eventRecord.isParent) {
              const routeDetails = eventRecord.data;
              items.setAsDestination.hidden = false;
              items.setAsDestination.disabled = routeDetails?.route_uid === this.routePicker.DESTINATION.selectedRoute?.route_uid;
            }
            else {
              items.setAsDestination.hidden = true;
            }
          },
        },
        eventTooltip: {
          hideDelay: 0,
          template: ((context: any): any => {
            const eventDetails = context.eventRecord.data;
            const detailsType: 'job' | 'route' = eventDetails?.detailsType;
            if (detailsType === 'job') {
              const jobDetails = eventDetails;
              return this.dispatchTemplateService.getJobDetailsTemplate(jobDetails, this.schedulerCurrentView, this.metaData);
            }
            else if (detailsType === 'route') {
              const routeDetails = eventDetails;
              return this.dispatchTemplateService.getRouteDetailsTooltipTemplate(routeDetails);
            }
          })
        },
        summary: {
          disabled: false,
          renderer: (event: any): string => {
            let eventIds = [];
            event?.events.forEach((eventModel: any) => {
              if (eventModel._data.detailsType === 'route') {
                eventIds.push(eventModel._data.id);
              }
            });
            eventIds = _.uniq(eventIds);
            return `<div class='cursor-default' eventIds=${eventIds.join(',')}>${eventIds.length}</div>`;
          }
        }
      }
    };
    this.setSchedulerStartEndDate();
    this.setSchedulerPreset();
    this.buildHolidaysTimeRange();
  }

  setSchedulerStartEndDate(setSchedulerDateBasedOnRoutes: boolean = true): void {
    const fromDate: Moment = this.routeFilters.date.clone().startOf('d');
    let toDate: Moment = this.routeFilters.date.clone().endOf('d');
    if (setSchedulerDateBasedOnRoutes && this.schedulerRoutes?.length) {
      const routeEndDates = this.schedulerRoutes.map((routeDetails: any) => moment(routeDetails?.route_end_time)).sort((one: any, two: any) => one.diff(two));;
      const nextDate = toDate.clone().add(1, 'd');
      if (routeEndDates?.length) {
        const effectiveRouteEndTime: Moment = routeEndDates[routeEndDates?.length - 1];
        if (!effectiveRouteEndTime.isAfter(nextDate) && effectiveRouteEndTime.isAfter(toDate)) {
          toDate = effectiveRouteEndTime.clone();
        }
      }
    }
    this.schedulerProConfig.startDate = fromDate.format('YYYY-MM-DD HH:mm:ss');
    this.schedulerProConfig.endDate = toDate.format('YYYY-MM-DD HH:mm:ss');
    if (this.schedulerInstance) {
      this.schedulerInstance.setStartDate(fromDate.format('YYYY-MM-DD HH:mm:ss'));
      this.schedulerInstance.setEndDate(toDate.format('YYYY-MM-DD HH:mm:ss'));
    }
    this.buildBusinessHoursTimeRange('add');
    this.setSchedulerScrollPosition(this.schedulerInstance, this.schedulerProConfig.startDate, this.schedulerCurrentView);
  }

  buildHolidaysTimeRange(): void {
    if (this.schedulerInstance) {
      this.dispatchBoardService.buildHolidaysTimeRange('MOVE-JOBS', this.schedulerInstance, this.holidays);
      this.isSchedulerHolidayTimeRangeMounted = true;
    }
  }

  setSchedulerPreset(schedulerPresets: any = this.schedulerPresets): any {
    const currentView = this.schedulerCurrentView;
    this.schedulerProConfig.presets = [];
    const currentPresets = schedulerPresets?.[currentView.toLowerCase()];
    if (!this.utilityService.isEmptyOrUndefined(currentPresets)) {
      this.schedulerProConfig.presets = currentPresets;
      if (this.schedulerInstance) {
        this.schedulerInstance.presets = currentPresets;
      }
    }
    if (currentView === 'DAY') {
      this.schedulerProConfig.viewPreset = 'customHourAndDay';
      if (this.schedulerInstance) {
        this.schedulerInstance.viewPreset = 'customHourAndDay';
      }

    } else if (currentView === 'WEEK' || currentView === 'MONTH') {
      this.schedulerProConfig.viewPreset = 'dayAndWeek';
      if (this.schedulerInstance) {
        this.schedulerInstance.viewPreset = 'dayAndWeek';
      }
    }
  }

  createBusinessHoursList(fromDate: any, toDate: any): Promise<any> {
    const timeRanges: any[] = [];
    return new Promise((resolve, reject) => {
      for (fromDate; fromDate.isSameOrBefore(toDate); fromDate.add(1, 'day')) {
        const isHolidayAdded = this.holidays.filter((holiday: any) => moment(holiday.date).isSame(fromDate, 'd')).length > 0;
        const businessHoursOnly = this.metaData?.scheduler.display.business_hours_only;
        if (!isHolidayAdded && !businessHoursOnly) {
          const id = timeRanges.length || 0;
          timeRanges.push({
            id: `obh_${id + 1}`, name: this.utilityService.getLocaleValue('dispatchBoard.scheduler.out_of_business_hours.title', 'Out of Business Hours'),
            startDate: fromDate.startOf('d').format(), endDate: moment(`${fromDate.format('YYYY-MM-DD')} ${this.dispatchBoardService.getBusinessHours('start')}`).format(), type: 'obh'
          });
          timeRanges.push({
            id: `obh_${id + 2}`, name: this.utilityService.getLocaleValue('dispatchBoard.scheduler.out_of_business_hours.title', 'Out of Business Hours'),
            startDate: moment(`${fromDate.format('YYYY-MM-DD')} ${this.dispatchBoardService.getBusinessHours('end')}`).format(), endDate: fromDate.endOf('d').format(), type: 'obh'
          });
        }
      }
      resolve(timeRanges);
    });
  }

  async buildBusinessHoursTimeRange(type?: 'add' | 'remove'): Promise<void> {
    let action: any = type;
    if (!type) {
      action = this.metaData?.scheduler.display?.business_hours_only ? 'remove' : 'add';
    }
    let timeRanges = [];
    if (this.schedulerInstance) {
      timeRanges = this.schedulerInstance?.timeRangeStore.data || [];
      timeRanges = timeRanges.filter((timeRange: any) => !timeRange.id.startsWith('obh_'));
      if (action === 'add') {
        if (this.schedulerCurrentView === 'DAY') {
          const startDate: Moment = moment(this.schedulerProConfig.startDate);
          const endDate: Moment =  moment(this.schedulerProConfig.endDate).clone();
          const fromDate = startDate.clone();
          const toDate = endDate.clone().endOf('d');
          timeRanges = await this.createBusinessHoursList(fromDate, toDate);
          timeRanges.forEach((timeRange: any) => {
            this.schedulerInstance.timeRangeStore.add(timeRange);
          });
        }
      }
      else if (action === 'remove') {
        this.dispatchBoardService.removeSchedulerOutOfBusinessTimeRange(this.schedulerInstance);
      }
    }
  }

  setSchedulerData(schedulerRouteData: any = this.routeListingData): void {
    this.schedulerEmployees = [];
    this.schedulerRoutes = [];
    this.schedulerJobs = [];
    this.schedulerAssignments = [];
    const routes = schedulerRouteData?.map((ele: any) => ({
      ...ele, id: ele.route_uid, detailsType: 'route', jobs: _.compact(ele.jobs.map((routeJob: any) => {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const jobDetails = routeJob?.job;
        if (jobDetails) {
          jobDetails.distance = routeJob?.distance || 0;
          jobDetails.sequence = routeJob?.sequence;
          jobDetails.time = routeJob?.time || 0;
          // eslint-disable-next-line @typescript-eslint/naming-convention
          jobDetails.route = { route_uid: ele.route_uid, route_name: ele.route_name };
          return { ...routeJob, job: jobDetails };
        }
      }))
    }));
    routes?.forEach((routeDetails: any, index: number) => {
      const routeJobs: any[] = [];
      let isRouteLocked: boolean = false;
      routeDetails.id = routeDetails.route_uid;
      routeDetails.manuallyScheduled = true;
      routeDetails.durationUnit = 'hour';
      routeDetails.duration = routeDetails.duration && routeDetails.duration !== 0 ? routeDetails.duration : 1;
      if (routeDetails.departure && routeDetails.route_end_time) {
        routeDetails.startDate = new Date(moment(routeDetails.departure).tz(this.timezone).format('YYYY-MM-DD HH:mm'));
        routeDetails.endDate = new Date(moment(routeDetails.route_end_time).tz(this.timezone).format('YYYY-MM-DD HH:mm'));;
      }
      if (routeDetails.is_deleted || routeDetails?.is_locked) {
        routeDetails.resizable = false;
        routeDetails.draggable = false;
        isRouteLocked = true;
      }
      if (routeDetails.jobs.length > 0) {
        routeDetails.jobs?.forEach((routeJob: any, _index: number) => {
          const job = routeJob?.job;
          if (job) {
            const jobStartDate = moment.utc(job.scheduled_start_time);
            const jobEndTimeDate = moment.utc(job.scheduled_end_time);
            const routeStartDate = moment.utc(routeDetails.departure);
            const routeEndDate = moment.utc(routeDetails.departure).add(routeDetails.duration, 'h');
            const isJobFitInsideRoute = jobStartDate.isBetween(routeStartDate, routeEndDate, null, '[]') || jobEndTimeDate.isBetween(routeStartDate, routeEndDate, null, '[]');
            if (isJobFitInsideRoute) {
              const distanceFromPreviousEvent: string = Number((job.time || 0) / 60).toFixed(0);
              job.id = job.job_uid;
              if (Number(distanceFromPreviousEvent) > 0) {
                job.preamble = `${distanceFromPreviousEvent} minutes`;
              }
              //TO-DO check last sequence job and add end location travel time (Need a fix from backend)
              if (_index === routeDetails.jobs.length - 1) {
                const distanceToEndLocation: string = Number((routeDetails.end_location?.time || 0) / 60).toFixed(0);
                if (Number(distanceToEndLocation) > 0) {
                  job.postamble = `${distanceToEndLocation} minutes`;
                  job.end_location_time = routeDetails.end_location?.time || 0;
                  job.end_location_distance = routeDetails.end_location?.distance || 0;;
                }
              }
              job.detailsType = 'job';
              job.transport_mode = routeDetails?.transport_mode;
              if (job.scheduled_start_time && job.scheduled_end_time) {
                job.startDate = new Date(moment(job.scheduled_start_time).tz(this.timezone).format('YYYY-MM-DD HH:mm'));
                job.endDate = new Date(moment(job.scheduled_end_time).tz(this.timezone).format('YYYY-MM-DD HH:mm'));
              }
              job.eventColor = '#3c763d';
              if (job.current_job_status && job.current_job_status.status_type === 'CLOSED') {
                job.resizable = false;
                job.draggable = false;
              }
              if (isRouteLocked) {
                job.draggable = false;
                job.resizable = false;
              }
              const jobAssignmentRecord = {
                id: job.job_uid + '_' + routeDetails.route_uid,
                eventId: job.job_uid,
                resourceId: routeDetails.route_uid
              };
              routeJobs.push(job);
              this.schedulerAssignments.push(jobAssignmentRecord);
            }
          }
        });
      }
      const assignmentRecord = {
        id: routeDetails.route_uid + '_' + routeDetails.route_uid,
        eventId: routeDetails.route_uid,
        resourceId: routeDetails.route_uid
      };
      this.schedulerAssignments.push(assignmentRecord);
      routeDetails.children = routeJobs;
      this.schedulerRoutes.push(routeDetails);
      this.schedulerJobs.push(...routeDetails?.children);
    });
    const users = schedulerRouteData; //Consider route as a user
    users?.forEach((route: any, index: any) => {
      route.name = route.route_name;
      route.id = route.route_uid;
      this.schedulerEmployees.push(route);
    });
    this.dispatchBoardService.setSchedulerRoutesRecords(this.schedulerRoutes);
    this.schedulerAssignments = _.uniqBy(this.schedulerAssignments, 'id');
    if (this.schedulerInstance) {
      this.schedulerInstance.eventStore.removeAll();
      this.schedulerInstance.resourceStore.removeAll();
      this.schedulerInstance.assignmentStore.removeAll();
      _.forEach(this.schedulerRoutes, (routeDetails: any) => {
        const eventRecord = this.schedulerInstance.eventStore.createRecord(routeDetails);
        this.schedulerInstance.eventStore.add(eventRecord);
      });
      this.schedulerProConfig.events = this.schedulerRoutes;
    }
    else {
      this.schedulerProConfig.events = this.schedulerRoutes;
    }
    this.schedulerProConfig.events = this.schedulerRoutes;
    this.schedulerProConfig.resources = this.schedulerEmployees;
    this.schedulerProConfig.assignments = this.schedulerAssignments;
    this.setSchedulerStartEndDate();
  }

  schedulerDateIncrementBtnState(action: 'enable' | 'disable'): void {
    this.routeFilters.disableDateButton.next = action === 'disable';
    this.routeFilters.disableDateButton.prev = action === 'disable';
  }
}

export type RoutePickerType = 'SOURCE' | 'DESTINATION';
